import { ROUTES } from "./data";

export const Marquee = () => {
  const items = [...ROUTES, ...ROUTES];
  return (
    <section id="routes" className="relative border-y border-[#12142b]/10 bg-[#f4f6fb] py-8">
      <div className="sr-marquee-track">
        {items.map((route, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl lg:text-6xl ${
                i % 2 === 0 ? "text-[#12142b]" : "sr-text-stroke"
              }`}
            >
              {route}
            </span>
            <span className="mx-8 text-3xl text-[#2340b5] lg:mx-12">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
